<div class="engine-tabs">
  <swiper [config]="config" [(index)]="index" class="nav nav-tabs engine__nav-tabs">
    <div class="nav-item engine__nav-item" *ngFor="let tab of tabs$ | async | filter:tabVisible">
      <a class="nav-link engine__nav-link"
         (click)="selectTab(tab.id)"
         id="{{tab.id}}-tab" [ngClass]="{'active': tab.id === this.selectedTabInner}">
        <i [ngClass]="tab.icon"></i>
        <span>{{tab.name}}</span>
      </a>
    </div>
  </swiper>
</div>
